import { Pipe, PipeTransform } from '@angular/core';
import { Auth, User, authState } from '@angular/fire/auth';
import { firstValueFrom } from 'rxjs';

@Pipe({
    name: 'authState',
    standalone: false
})
export class AuthStatePipe implements PipeTransform {
  constructor(private auth: Auth) {}

  transform(value: any): Promise<User | null> {
    return firstValueFrom(authState(this.auth));
  }
}
